import { render, staticRenderFns } from "./ModuleChildService.vue?vue&type=template&id=4982fd3f"
import script from "./ModuleChildService.vue?vue&type=script&lang=js"
export * from "./ModuleChildService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports